import localforage from 'localforage';
import _ from 'lodash';
import { useCallback, useContext, useState } from 'react';
import { FavoritesContext } from '../FavoritesContext';

export const useFavorites = () => {

  const favoritesContext = useContext(FavoritesContext)
  const { favorites_handlers } = favoritesContext ?? {}

  const [appUserFavs, setAppUserFavs] = useState()

  const getPageFavGroup = (pathViews) => {
    if (pathViews.teams) {
      return 'teams'
    } else if (pathViews.sports) {
      return 'sports'
    } else if (pathViews.districts) {
      return 'districts'
    }
  }

  const getAppUserFavs = useCallback(async () => {
    const favs = await localforage.getItem('appUserFavs')
    setAppUserFavs(favs?.data || {})
    return favs?.data || {}
  }, [])

  const updateAppUserFav = useCallback(async ({ eventFavs, pathViews, favItem, favGroup, parentProps, callback }) => {

    // if (!appUserAccessType || !uid) return;

    const _favGroups = {
      sports: eventFavs?.['sports'],
      districts: eventFavs?.['districts'],
      teams: eventFavs?.['teams'],
    }

    const pageFavGroup = getPageFavGroup(pathViews)
    const _fav_group = favGroup || pageFavGroup

    const _favItem = {
      name: favItem.name,
      pathName: favItem.pathName,
      pageKey: favItem.pageKey || favItem?.[pageFavGroup]
    }

    const _fav_groups = _.cloneDeep(_favGroups || {})
    const _favGroup = _fav_groups[_fav_group] || {}
    const _favGroupItem = _favGroup[_favItem.pageKey]

    if (_favGroupItem) {
      delete _favGroup[_favItem.pageKey]
      if (_.isEmpty(_favGroup)) {
        delete _fav_groups[_fav_group]
      }
      // unsubscribe = true
    } else {
      _fav_groups[_fav_group] = {
        ..._favGroup,
        [_favItem.pageKey]: {
          name: _favItem.name,
          pathName: _favItem.pathName,
          ...parentProps,
        }
      }
      // unsubscribe = false
    }

    await localforage.setItem('appUserFavs', { data: _fav_groups })
    setAppUserFavs(_fav_groups);
    favorites_handlers.ammendFavorites(_fav_groups)

  }, []);

  return { updateAppUserFav, getAppUserFavs, appUserFavs }
}
